module.exports = __webpack_public_path__ + "img/symbol_4.2b255f2b.png";